/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Content_ScriptsInputs */

const en_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content scripts`)
};

const ar_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سكربتات المحتوى`)
};

const bn_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কনটেন্ট স্ক্রিপ্ট`)
};

const de_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsskripte`)
};

const es_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`guiones de contenido`)
};

const fr_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts de contenu`)
};

const pt_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts de conteúdo`)
};

const zh_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容脚本`)
};

const tr_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçerik komut dosyaları`)
};

const ru_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрипты контента`)
};

const pl_svchip_content_scripts = /** @type {(inputs: Svchip_Content_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrypty treści`)
};

/**
* | output |
* | --- |
* | "Content scripts" |
*
* @param {Svchip_Content_ScriptsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_content_scripts = /** @type {((inputs?: Svchip_Content_ScriptsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Content_ScriptsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_content_scripts(inputs)
	if (locale === "bn") return bn_svchip_content_scripts(inputs)
	if (locale === "de") return de_svchip_content_scripts(inputs)
	if (locale === "es") return es_svchip_content_scripts(inputs)
	if (locale === "fr") return fr_svchip_content_scripts(inputs)
	if (locale === "pt") return pt_svchip_content_scripts(inputs)
	if (locale === "zh") return zh_svchip_content_scripts(inputs)
	if (locale === "tr") return tr_svchip_content_scripts(inputs)
	if (locale === "ru") return ru_svchip_content_scripts(inputs)
	if (locale === "pl") return pl_svchip_content_scripts(inputs)
	return en_svchip_content_scripts(inputs)
});